import { render } from "./low-stock.vue?vue&type=template&id=599546ba&scoped=true"
import script from "./low-stock.vue?vue&type=script&lang=js"
export * from "./low-stock.vue?vue&type=script&lang=js"

import "./low-stock.vue?vue&type=style&index=0&id=599546ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599546ba"]])

export default __exports__